import { render, staticRenderFns } from "./UndeliveredOrdersByDateAndTour.vue?vue&type=template&id=857cfb18&"
import script from "./UndeliveredOrdersByDateAndTour.vue?vue&type=script&lang=js&"
export * from "./UndeliveredOrdersByDateAndTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports